
import { defineComponent, PropType, computed, } from 'vue';
import hlsPlayer from './hlsplayer.vue';
import flvPlayer from './flvPlayer.vue';

export default defineComponent({
  components: {
    flvPlayer,
  },
  props: {
    urls: {
      type: Array as PropType<string[]>,
      required: true,
      default: () => [],
    },
    // 播放器数量
    playerNum: {
      type: Number,
    },
  },
  setup (props, { emit, }) {
    // 播放器url
    const showUrls = computed(() => {
      const { urls, playerNum, } = props;
      const tmpUrls = [];
      // 最多显示9个
      const len = Math.min(playerNum ?? urls.length, 9);

      for (let i = 0; i < len; i++) {
        tmpUrls.push(urls[i] ?? '');
      }

      return tmpUrls;
    });
    // 画幅类型
    const frameNum = computed<number>(() => {
      // 有playerNum时，优先按playerNum设置画幅
      const val = props.playerNum ?? props.urls.length;

      if (val > 4) {
        return 9;
      }
      if (val > 1) {
        return 4;
      }

      return 1;
    });

    return {
      showUrls,
      frameNum,
    };
  },
});
